import React from 'react';

import { type WaypointFeatureTier } from '@dashboard/generated/wp/authentication';
import { CheckCircleOutlined } from '@mui/icons-material';
import { Box, Button, Card, Chip, Stack, Typography } from '@mui/material';

import { getDescription, getLabel } from '../helpers';

type Props = {
  tier: WaypointFeatureTier;
  isCurrent: boolean;
  isSelected: boolean;
  onSelect: (tier: WaypointFeatureTier) => void;
};

export default function PlanCard({ tier, isCurrent, isSelected, onSelect }: Props) {
  const description = getDescription(tier);
  const label = getLabel(tier);
  const renderButton = () => {
    if (isSelected) {
      return (
        <Stack direction="row" spacing={1} alignItems="center" sx={{ color: 'brand.blue', px: 1 }}>
          <CheckCircleOutlined fontSize="small" />
          <Typography fontWeight="medium">Selected</Typography>
        </Stack>
      );
    }

    return (
      <Button onClick={() => onSelect(tier)} variant="outlined">
        Select
      </Button>
    );
  };

  const renderCurrentPlanChip = () => {
    if (!isCurrent) {
      return null;
    }
    return <Chip label="Current plan" color="primary" size="small" sx={{ mt: 2 }} />;
  };

  return (
    <Card
      variant="outlined"
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderColor: isSelected ? 'brand.blue' : 'grey.300',
      }}
    >
      <Box>
        <Typography fontWeight="medium">{label}</Typography>
        <Typography color="text.secondary">{description}</Typography>
        {renderCurrentPlanChip()}
      </Box>
      <Box>{renderButton()}</Box>
    </Card>
  );
}
